import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Loader2 } from 'lucide-react';

// Component for generation output within a proposal
export const GenerationOutput = ({ output, proposalId, taskId }: { output: string; proposalId: string; taskId: string }) => {
  const outputRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (outputRef.current) {
      outputRef.current.scrollTop = outputRef.current.scrollHeight;
    }
  }, [output]);

  return (
    <div className="mt-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          Generation Progress
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(`/pages/generation-progress/?taskId=${taskId}&proposalId=${proposalId}`)}
        >
          Full Screen
        </Button>
      </div>
      <ScrollArea className="h-[400px] w-full border rounded-md">
        <div
          ref={outputRef}
          className="bg-black/80 text-white p-4 font-mono text-xs whitespace-pre-wrap"
        >
          {output || 'Waiting for output...'}
        </div>
      </ScrollArea>
    </div>
  );
};